<script>
import RoadmapCta from '@/components/Discover/RoadmapCta'
import OpeningsCta from '@/components/Discover/OpeningsCta'
import RecruitmentCta from '@/components/Recruit/RecruitmentCta'

export default {
    name: 'DiscoverButtons',

    props: {
        name: String,
        label: String,
        tag: {
            type: String,
            default: 'aside'
        },
        headingTag: {
            type: String,
            default: 'h2',
        },
        classes: {
            type: String,
            default: 'slide__details'
        },
    },

    components: {
        RoadmapCta,
        OpeningsCta,
        RecruitmentCta
    },

    render(h) {
        const { name, classes } = this

        const buttons = [
            h(RoadmapCta),
            this.isMobile() && h(OpeningsCta),
            this.isMobile() && h(RecruitmentCta)
        ]
        
        return h(this.tag, {
            class: classes,
            attrs: {
                'aria-labelledby': name || "",
            }
        }, [
            h(this.headingTag, {
                class: 'subtitle',
                domProps: {
                    id: name || "",
                    innerHTML: 'Create your own story'
                }
            }),
            ...buttons,
        ])
    }
}
</script>